/**
 * Task #50 — durable "open this pulse's workbench" intent.
 *
 * Mirrors the quick-search `pin-intent` pattern: the unlinked-email-pulses
 * dialog sets this intent right before navigating to `/?projectId=…` and
 * dispatching the fast-path `open-pulse-workbench` window event. When the
 * dashboard tree is already mounted, the event listener opens the workbench
 * instantly AND consumes this intent (so it can't fire twice later). When
 * the click happens from a non-dashboard route (admin page, settings) or a
 * cold start where `ProjectTree` mounts after the event was dispatched, the
 * event is lost — but the intent survives the route transition and is
 * consumed by `ProjectTree` on mount, so the click never silently no-ops.
 */

interface PulseWorkbenchIntent {
  pulseId: number;
}

let pending: PulseWorkbenchIntent | null = null;

export function setPulseWorkbenchIntent(intent: PulseWorkbenchIntent) {
  pending = intent;
}

/** Read-and-clear atomically; returns null when nothing is pending. */
export function consumePulseWorkbenchIntent(): PulseWorkbenchIntent | null {
  const value = pending;
  pending = null;
  return value;
}
